import { Component, inject, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableHeaderComponent } from '../table-header/table-header.component';
import { SharedModule } from 'primeng/api';
import { TableModule } from 'primeng/table';
import { Company, CompanyEnum } from '../../models/company.model';
import { JuniorTransfers } from '../../models';
import { Currency } from '../../models/currency.model';
import { PricePipe } from '@lx/shared/ui/pipes';
import { Note } from '../../models/types';
import { NotesComponent } from '../notes/notes.component';
import { SubjectEnum } from '../../utils/notes.utils';
import { PriceListNote } from '../../models/priceslist-note.model';
import { NotesService } from '../../services/notes.service';

@Component({
  standalone: true,
  selector: 'lx-price-lists-portal-camps-transfers-table',
  imports: [CommonModule, TableHeaderComponent, SharedModule, TableModule, PricePipe, NotesComponent],
  templateUrl: './camps-transfers-table.component.html',
  styleUrls: ['./camps-transfers-table.component.scss'],
})
export class CampsTransfersTableComponent implements OnInit {
  @Input() company: Company = CompanyEnum.ALP;
  @Input() currency: Currency | undefined;
  @Input() transfers: JuniorTransfers[] | undefined;
  @Input() transferNotes: PriceListNote[] | undefined;
  @Input() transferNotesSubject: SubjectEnum = SubjectEnum.TRANSFER_SERVICE_FEES;
  notes: Note[] | undefined;
  notationMarks: Record<string, string> | undefined;

  private readonly notesService = inject(NotesService);

  ngOnInit(): void {
    const filteredTransferNotes = this.notesService.getNotes(this.transferNotes, this.transferNotesSubject);
    if (filteredTransferNotes) {
      [this.notes, this.notationMarks] = filteredTransferNotes;
    }
  }
}
